module.exports = __webpack_public_path__ + "static/media/Partner16.92c58545.webp";